/* eslint-disable */
import React, { useEffect } from 'react';
import { generatePath } from 'react-router-dom';
import { useState, Downgraded } from '@hookstate/core';
import { Box, IconButton, Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
// import stores
import { useAuthState } from '../../stores/authStore';
// import { exitTheme } from '../../hookState/ThemeState';
// import utility and constants
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import RouteConstants from '../../constants/routeConstants';
// import shared components
import DataList from '../Users/dataList';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { FULL_PERMISSION } from '../../constants/Constant';
import SendUserInvitationEMail from '../../modules/Users/sendUserInvitationEmail';
import moment from 'moment';
import CultureInfo from '../../utility/cultureInfo';
import Helper from '../../utility/helper';
import Title from '../../sharedcomponents/title/title';
import SendBulkUserInvitationEmail from '../../modules/Users/sendBulkUserInvitationEmail';
import CustomDataGrid from '../../sharedcomponents/customDataGrid/customdatagrid';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { excelFileType, ScheduleUserType } from '../../constants/Constant';
import { useHistory } from 'react-router-dom';
import EnhancedEncryptionOutlinedIcon from '@mui/icons-material/EnhancedEncryptionOutlined';
import ChangePassword from './changePassword';
import * as forge from 'node-forge';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};

const UserList = (props) =>
{
    const userInvitationInfo = useState(null);
    const users = useState();
    const userSearchData = useState([]);

    const history = useHistory();

    // const [searchUser, setSearchUser] = React.useState('');
    const loading = useState(false);
    // const [userList, setUserList] = React.useState([]);
    const authState = useAuthState();
    const modPermission = FULL_PERMISSION;
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [showChangePasswordDialog, setShowChangePasswordDialog] = React.useState(false);
    const [rowUserData, setRowUserData] = React.useState();
    const [submitButtonLoader, setSubmitButtonLoader] = React.useState(false);
    
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const bulkInviteConfirmation = useState({
        open: false,
        title: '',
        message: '',
        emailObj: ''
    });

    // const [configData, setConfigData] = useState({
    //     subject:'',
    //     body:''
    // })
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const openSendEmail = useState(false);

    const openBulkSendEmail = useState(false);
    const sendBulkEmailObj = useState([]);

    const [bulkInviteSelected, setBulkInviteSelected] = React.useState(false);
    const [searchData, setSearchData] = React.useState([])
    const [columns, setColumns] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [selectedRecords, setSelectedRecords] = React.useState([]);
    const [uploadUserLoader, setUploadUserLoader] = React.useState(false);

    const editSendEmail = (info) =>
    {
        openSendEmail.set(true);
        userInvitationInfo.set({userID: info.userID});
    };
    const closeSendEmail = () =>
    {
        openSendEmail.set(false);
    };
    const closeBulkSendEmail = () =>
    {
        openBulkSendEmail.set(false);
    };
    const copyToClipboard = (info) =>
    {
        const userInfo = Helper.getStorage('userInfo');
        ApiHelper.get(
            APIURLConstants.GET_USER_INVITATION(
                info.userID,
                null,
                userInfo.userID
            )
        ).then((res) =>
        {
            if (res)
            {
                const el = document.createElement('textarea');
                el.value = res.data.code;
                el.setAttribute('readonly', '');
                el.style.position = 'absolute';
                el.style.left = '-9999px';
                document.body.appendChild(el);
                el.select();
                el.setSelectionRange(0, 99999);
                document.execCommand('copy');
                document.body.removeChild(el);
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'Copied',
                });
            }
        });

    };

    useEffect(() =>
    {
        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        )
        {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: 5000,
                noOfPages: null,
            });
        }

    }, [authState]);

    // useEffect(() =>
    // {
    //     exitTheme();
    // }, []);
    const updateActualUsersData = () => {
        
    }
    const getUsersList = () =>
    {
        loading.set(true);

        ApiHelper.get(
            APIURLConstants.GET_ALL_USER_LIST(
                pagingInfo.get().currentPage,
                pagingInfo.get().itemsPerPage
            )
        )
            .then((res) =>
            {
                userSearchData.set(res.data.rows);
                let usersData = [];
                const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                if (res.data.rows)
                {
                    setColumns([
                        { key: 'name', name: 'Name', width: '30%',
                        renderCell({row}) { return (<Box sx={{display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
                                {row.name}
                                {row.email && row.email != '' ? <>&nbsp;(<a href={`mailto: ${row.email}`} style={{lineHeight: 0, fontSize: 10}}>{row.email}</a>)</> : null}
                            </Box>) 
                        }},
                        { key: 'loginID', name: 'LoginID', width: '15%' },
                        // { key: 'email', name: 'Email' },
                        { key: 'roleName', name: 'Role', width: '10%' },
                        { key: 'registerDate', name: 'Registered On', width: '20%' },
                        { key: 'statusact', name: 'Status', width: '9%' },
                        { key: 'action', name: 'Action', width: '13%', renderCell({row}) { 
                            const nbaDomain = (row.loginID !== undefined && row.loginID !== null) ? row.loginID.split("@") : "";
                            const nbaDomains =  (nbaDomain && nbaDomain[1] === undefined ? true : (nbaDomain[1] === "nba.com" || nbaDomain[1] === "wnba.com"))
                            return (
                            <>
                                <Tooltip title="Send" aria-label="send">
                                    <IconButton
                                        color="primary"
                                        onClick={() => editSendEmail(row)}
                                        disabled={!row.showEmailIcon || row.active == 0}>
                                        <EmailIcon
                                            fontSize="small"
                                            color={
                                                row.showEmailIcon && row.active == 1
                                                    ? 'primary'
                                                    : 'default'
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Copy To Clipboard" aria-label="copyToClipboard">
                                    <IconButton
                                        color="primary"
                                        onClick={() => copyToClipboard(row)}
                                        disabled={
                                            !row.showClipBoardIcon ||
                                            row.active == 0
                                        }
                                    >
                                        <ContentCopyOutlinedIcon
                                            fontSize="small"
                                            color={
                                                row.showClipBoardIcon &&
                                                row.active == 1
                                                    ? 'primary'
                                                    : 'default'
                                            }
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Edit" aria-label="edit">
                                    <IconButton
                                        color="primary"
                                        onClick={() => editUser(row)}
                                        disabled={false}>
                                        <EditOutlinedIcon
                                            fontSize="small"
                                            color={'primary'}
                                        />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Change Password" aria-label="change Password">
                                    <IconButton
                                        color="primary"
                                        onClick={() => changePassword(row)}
                                        disabled={nbaDomains}>
                                        <EnhancedEncryptionOutlinedIcon
                                            fontSize="small"
                                            color={!nbaDomains
                                                ? 'primary'
                                                : 'default'}
                                        />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}}
                    ]);
                    let actRows = [];
                    res.data.rows.map((item,index) => {
                        actRows.push({
                            id: `user_${index}_${item.userID}`,
                            userID: item.userID,
                            name: item.lastName + ',' + item.firstName,
                            email: item.email,
                            loginID: item.loginID,
                            roleName: item.roleName,
                            registerDate: item.registerDate != null ? moment(item.registerDate).format(CultureInfo.GetCultureInfo().DateTimeFormat) : '',
                            statusact: item.active ? 'Active' : 'Inactive',
                            active: item.active,
                            showClipBoardIcon: item.status == 0 ? true : false,
                            showEmailIcon: item.status == 0 ? true : false
                        });
                    })
                    setRows(actRows);
                    res.data.rows.slice(indexOfFirstRecord, indexOfLastRecord).map((item) =>
                    {
                        usersData.push({
                            actualData: item,
                            // row: [
                            //     {
                            //         label: 'checkbox',
                            //         key: 'userID',
                            //         userID: item.userID,
                            //         width: '0.05',
                            //     },
                            //     // {
                            //     //     label: 'First Name',
                            //     //     key: 'firstName',
                            //     //     firstName: item.firstName,
                            //     //     inColumn: true,
                            //     //     width: '0.15',
                            //     // },
                            //     // {
                            //     //     label: 'Last Name',
                            //     //     key: 'lastName',
                            //     //     lastName: item.lastName,
                            //     //     inColumn: true,
                            //     //     width: '0.15',
                            //     // },
                            //     // {
                            //     //     label: 'Email',
                            //     //     key: 'email',
                            //     //     email: item.email,
                            //     //     inColumn: true,
                            //     //     width: '0.25',
                            //     // },
                            //     {
                            //         label: 'Name',
                            //         key: 'participant',
                            //         participant: item.lastName + ',' + item.firstName,
                            //         showLabel: false,
                            //         width: '0.25',
                            //         inColumn: true,
                            //         showEmail: true,
                            //         toEmail: item.email,
                            //     },
                            //     {
                            //         label: 'Login ID',
                            //         key: 'email',
                            //         email: item.loginID,
                            //         inColumn: true,
                            //         width: '0.3',
                            //     },
                            //     {
                            //         label: 'Role',
                            //         key: 'roleName',
                            //         roleName: item.roleName,
                            //         inColumn: true,
                            //         width: '0.1',
                            //     },
                            //     {
                            //         label: 'Registered On',
                            //         key: 'registerDate',
                            //         registerDate: item.registerDate != null ? moment(
                            //             item.registerDate
                            //         ).format(
                            //             CultureInfo.GetCultureInfo()
                            //                 .DateTimeFormat
                            //         ) : '',
                            //         inColumn: true,
                            //         width: '0.15',
                            //         isSent: true,
                            //     },
                            //     {
                            //         label: 'Status',
                            //         key: 'status',
                            //         status: item.active ? 'Active' : 'Inactive',
                            //         width: '0.07',
                            //         inColumn: true,
                            //     },
                            //     {
                            //         label: 'SenUserMail',
                            //         key: 'sendUserMail',
                            //         showLabel: false,
                            //         width: '0.03',
                            //         showEmailIcon:
                            //             item.status == 0 ? true : false,
                            //     },
                            //     {
                            //         label: 'ClipBoard',
                            //         key: 'clipBoard',
                            //         width: '0.03',
                            //         showClipBoardIcon: item.status == 0 ? true : false,
                            //     },
                            //     {
                            //         label: 'Action',
                            //         key: 'edit',
                            //         edit: 'Edit',
                            //         width: '0.02',
                            //     }
                            // ],
                            selected: false,
                        });
                    });

                }

                users.set(usersData);
                loading.set(false);
                pagingInfo.set({
                    ...pagingInfo,
                    currentPage: pagingInfo.get().currentPage,
                    itemsPerPage: pagingInfo.get().itemsPerPage,
                    noOfPages: Math.ceil(
                        res.data.totalCount / pagingInfo.get().itemsPerPage
                    ),
                });
            })
            .catch((error) =>
            {
                loading.set(false);
                if (error.response && error.response.status === 401)
                {
                    alert(error);
                }
            });
    };
    useEffect(() =>
    {
        const pageInfo = pagingInfo.attach(Downgraded).get();
        if (pageInfo.itemsPerPage)
        {
            getUsersList();
        }
    }, []);

    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getUsersList();
    };

    const handleConfirmation = () =>
    {
        let deleteUsers = [];        
        selectedRecords.map((user) =>
        {
            if (user.selected === true)
            {
                deleteUsers.push(user.actualData.userID);
            }
        });

        ApiHelper.post(APIURLConstants.DELETE_USERS, {
            Ids: deleteUsers.join(','),
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Users deleted successfully',
                    });
                    setShowSearchRec(false);
                    setSelectedRecords([]);
                    setSearchData([]);
                    getUsersList();
                }
            })
            .catch((error) =>
            {
                console.log('error : ', error);
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting users';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });

        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const redirectToCreate = () =>
    {
        history.push({
            pathname: RouteConstants.CREATE_USER,
            state: {},
        });
    };

    const editUser = (user) =>
    {
        const path = generatePath(RouteConstants.EDIT_USER, {
            userID: user.userID,
        });
        history.push({
            pathname: path,
            state: {},
        });
    };
    const changePassword = (user) => {
        // console.log(user);
        setRowUserData(user)
        setShowChangePasswordDialog(true)
    }
    const deleteUsers = () =>
    {
        let selected = '';
        if (selectedRecords.length > 0) {
            selected = selectedRecords.filter((user) => user.selected === true); 
        }
        else if(searchData.length !== 0 ){
            selected = searchData.filter((user) => user.selected === true); 
        } else if (bulkInviteSelected != false)
        {
            selected = (userSearchData.get().filter((user) =>
            {
                const nbaDomain = (user.email !== undefined && user.email !== null) ? user.email.split("@") : ""
                return ((user.registerDate === null) && (nbaDomain && nbaDomain[1] !== "nba.com"))
            }));
        } else
        {
            selected = users.get().filter((user) => user.selected === true);
        }

        // console.log("selected",searchData, users.get());
        if (selected.length === 0)
        {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select user first',
            });
        } else
        {
            let message =
                selected.length == users.get().length
                    ? 'Do you want to delete all users ?'
                    : 'Do you want to delete selected users ?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const handleBulkInviteConfirmation = () =>
    {
        const data = bulkInviteConfirmation.attach(Downgraded).get()
        sendBulkEmailObj.set(data.emailObj)
        openBulkSendEmail.set(true);
        setSearchData([]);
        getUsersList();
        bulkInviteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: "",
            emailObj: []
        });

    }
    const handleBulkInviteCancel = () =>
    {
        // getUsersList()
        bulkInviteConfirmation.set({
            ...bulkInviteConfirmation.get(),
            open: false,
        });
    }
    const inviteHandleClick = () =>
    {
        if (!bulkInviteSelected)
        {
            const selected = 
            selectedRecords.length > 0 ? selectedRecords.filter((user) =>
            {
                const nbaDomain = (user.actualData.email !== undefined && user.actualData.email !== null) ? user.actualData.email.split("@") : ""
                return ((user.selected === true) && (nbaDomain && nbaDomain[1] !== "nba.com"))
            })
            :
            searchData.length === 0 ? users.get().filter((user) =>
            {
                const nbaDomain = (user.actualData.email !== undefined && user.actualData.email !== null) ? user.actualData.email.split("@") : ""
                return ((user.selected === true) && (nbaDomain && nbaDomain[1] !== "nba.com"))
            }) : searchData.filter((user) =>
            {
                const nbaDomain = (user.actualData.email !== undefined && user.actualData.email !== null) ? user.actualData.email.split("@") : ""
                return ((user.selected === true) && (nbaDomain && nbaDomain[1] !== "nba.com"))
            })

            const emailObj = selected.map((item) =>
            {
                return {
                    email: item.actualData.email,
                    userID: item.actualData.userID,
                    firstName: item.actualData.firstName,
                    lastName: item.actualData.lastName
                };
            });

            if (selected.length === 0)
            {
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select participants first',
                });
            } else
            {
                sendBulkEmailObj.set(emailObj)
                openBulkSendEmail.set(true)
            }

        } else
        {
            const selected = userSearchData.get().filter((user) =>
            {
                const nbaDomain = (user.email !== undefined && user.email !== null) ? user.email.split("@") : ""
                return ((user.registerDate === null) && (nbaDomain && nbaDomain[1] !== "nba.com"))
            });

            const emailObj = selected.map((item) =>
            {
                return {
                    email: item.email,
                    userID: item.userID,
                    firstName: item.firstName,
                    lastName: item.lastName
                };
            });

            if (selected.length === 0)
            {
                setSnackBarProps({
                    snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: 'Please select participants first',
                });
            } else
            {
                let message = 'This will send Email to the all Users, Press OK to Continue';
                bulkInviteConfirmation.set({
                    open: true,
                    title: '',
                    OkButtonText: 'Ok',
                    message: message,
                    emailObj: emailObj
                });
            }
        }
    };
    function importBulkUser(obj) {
        return ApiHelper.post(APIURLConstants.BULK_USER_EXCEL_IMPORT, obj)
            .then((result) => {
                return result.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    const handleMassUpdateImportUser = (attachmentDocument) => {
        const userInfo = Helper.getStorage('userInfo');
        if (attachmentDocument && attachmentDocument.target.files[0]) {
            let uploadFile = attachmentDocument.target.files[0];
            if (excelFileType.includes(uploadFile.type)) {
                let form = new FormData();
                //setIsLoading(true);Activity import failed.
                form.append('attachedFile', uploadFile);               
                form.append('createdBy', userInfo.userID);
                setUploadUserLoader(true)
                importBulkUser(
                    form
                )
                    .then((response) => {
                        let result = response;
                        setUploadUserLoader(false)
                        if (result.status > 0) {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'success',
                                message: result.message,
                            });
                            getUsersList();
                        } else {
                            setSnackBarProps({
                                openSnack: true,
                                variant: 'error',
                                message: result.message,
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setUploadUserLoader(false)
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'User import failed.',
                        });
                    });
            } else {
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message:
                        'Invalid file format, Please upload valid excel file.',
                });
            }
        } else {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select a file to upload.',
            });
        }
        attachmentDocument.target.value = null;
    };
    
    const updateBulkUserExcelReport = () => {
        ApiHelper.post(
            APIURLConstants.GET_BULK_USER_EXCEL_EXPORT, {
            EventID: 0,
            ModuleID: 0
        }).then((res) => {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject) {
                if (finalObject.length > 0) {
                    let header = {};
                    Object.keys(finalObject[0]).forEach((key) => {
                        header[key] = key;
                    });
    
                    // Create an array with only the header object
                    const headerOnlyArray = [header];
                    
                    // Call the helper to download the report with headers only
                    Helper.downloadReport(
                        headerOnlyArray,
                        `Bulk_Upload-User-Report`
                    );
                }
            }
        });
    };
    const closeChangePasswordDialog = () => {
        setShowChangePasswordDialog(false)
        setRowUserData('')
    }
    const handleChangePasswordSubmit = (password, confPassword) => {
        // console.log(password, confPassword);
        setSubmitButtonLoader(true)
        const publicKey = process.env.REACT_APP_PUBLIC_KEY;

        var rsa = forge.pki.publicKeyFromPem(publicKey);
        let encryptedPassword = window.btoa(rsa.encrypt(password));
        const data = {
            username: rowUserData.loginID,
            currentPassword: password,
            newPassword: encryptedPassword
          }

        ApiHelper.post(APIURLConstants.CHANGE_PASSWORD, data)
            .then((res) => {
                setSubmitButtonLoader(false)
                if (res.data.status === 200) { 
                    const response = (res.data);
                    console.log(response)
                    if (response.ok) {
                        snackBarProps.openSnack = true;
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: 'Password changed successfully',
                        });
                        setShowChangePasswordDialog(false)
                    } else {
                        snackBarProps.openSnack = true;
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: response.message == "" ? "Something went wrong" : response.message,
                        });
                        setShowChangePasswordDialog(false)
                    }
                }else if(res.data.message === null && res.data.status === 0 && res.data.response === null) {
                    snackBarProps.openSnack = true;
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: "Please contact Matt Futterman (mfutterman@nba.com) for this issue.",
                    });
                    setShowChangePasswordDialog(false)
                } else {
                    snackBarProps.openSnack = true;
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: res.data.message,
                    });
                    setShowChangePasswordDialog(false)
                } 
            })
            .catch((error) => {
                let message = 'Something went wrong!';
                setSubmitButtonLoader(false)
                console.log(error)
                snackBarProps.openSnack = true;
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                setShowChangePasswordDialog(false)
            });
                
    }

    return (
        <Box
            sx={{
                width: '100%',
                boxShadow:
                    'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
                borderRadius: 4,
                // pt: 1,
                // pr: 3,
                // pb: 1,
                // pl: 3,
                padding: '8px 16px',
                backgroundColor: '#fff',
            }}>
            <Box
            sx={{
                margin:'10px'
            }}
            >
                <Title
                    title={'List Of Users'}
                    sx={{
                        ml: 0,
                    }}
                    px={0}
                />
            </Box> 




            {loading.get() ? (
                <Box style={loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <CustomDataGrid 
                    columns={columns} 
                    rows={rows} 
                    actualUsersData={users.attach(Downgraded).get()}
                    updateActualUsersData={updateActualUsersData}
                    showSearch={true}
                    searchLabel={'Search'}
                    showSendInvite={true}
                    buttonTitle={'Add'}
                    bulkInviteSelected={bulkInviteSelected}
                    setBulkInviteSelected={setBulkInviteSelected}
                    inviteHandleClick={inviteHandleClick}
                    modPermission={modPermission}
                    deleteRows={deleteUsers}
                    setSearchData={setSearchData}
                    setSelectedRecords={setSelectedRecords}
                    handleClick={redirectToCreate}
                    importFileType={excelFileType}
                    // showUploadMassUpdateUser={true}
                    handleMassUpdateImportUser={handleMassUpdateImportUser}
                    updateTemplate={updateBulkUserExcelReport}
                    // showUpdateTemplate={true}
                />
                // <DataList
                //     data={users.attach(Downgraded).get()}
                //     userSearchData={userSearchData.attach(Downgraded).get()}
                //     editRow={editUser}
                //     handleClick={redirectToCreate}
                //     // title={'List Of Users'}
                //     buttonTitle={'Add'}
                //     deleteRows={deleteUsers}
                //     showSendInvite={true}
                //     showSelectAll={true}
                //     bulkInviteSelected={bulkInviteSelected}
                //     setBulkInviteSelected={setBulkInviteSelected}
                //     inviteHandleClick={inviteHandleClick}
                //     showSearch={true}
                //     searchLabel={'Search'}
                //     showSearchRec={showSearchRec}
                //     setShowSearchRec={setShowSearchRec}
                //     getResults={getUsersList}
                //     pagingInfo={pagingInfo.attach(Downgraded).get()}
                //     handlePageChange={handlePageChange}
                //     modPermission={modPermission}
                //     setSearchData={setSearchData}
                //     editSendEmail={editSendEmail}
                //     copyToClipboard={copyToClipboard}
                // />
            )}
            {openSendEmail.get() && (
                <SendUserInvitationEMail
                    open={openSendEmail.get()}
                    userInvitationInfo={userInvitationInfo
                        .attach(Downgraded)
                        .get()}
                    title="Send User Invitation"
                    handleClose={closeSendEmail}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getUsersList={getUsersList}
                />
            )}
            {openBulkSendEmail.get() && (
                <SendBulkUserInvitationEmail
                    open={openBulkSendEmail.get()}
                    emailIds={sendBulkEmailObj
                        .attach(Downgraded)
                        .get()}
                    title="Send Bulk User Invitation"
                    handleClose={closeBulkSendEmail}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getUsersList={getUsersList}
                />
            )}
            {
                <ConfirmationDialog
                    open={bulkInviteConfirmation.get().open}
                    message={bulkInviteConfirmation.get().message}
                    OkButtonText={bulkInviteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleBulkInviteConfirmation(bulkInviteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        handleBulkInviteCancel()
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        //getUsersList()
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
             {showChangePasswordDialog && (
                <ChangePassword
                    open={showChangePasswordDialog}
                    title={`Change Password`}
                    handleClose={closeChangePasswordDialog}
                    data={rowUserData}
                    submitButtonLoader={submitButtonLoader}
                    handleChangePasswordSubmit={handleChangePasswordSubmit}
                />
            )}
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: false,
                        })
                    }></CustomizedSnackbars>
            )}
        </Box>
    );
};

export default UserList;
